'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useReCaptcha } from 'next-recaptcha-v3';
import { useHelpWidget } from '../HelpWidgetContext';
import submitOrderStatusAction from '../actions/orderStatusAction';
const HelpOrderStatus = () => {
  const {
    setPanel
  } = useHelpWidget();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const {
    executeRecaptcha
  } = useReCaptcha();
  const handleSubmit = async formData => {
    setIsPending(true);
    setError(null);
    setFieldErrors({});
    try {
      const token = await executeRecaptcha('order_status');
      formData.set('recaptcha_token', token);
      const response = await submitOrderStatusAction(formData);
      if (response.success) {
        setIsSubmitted(true);
      } else {
        if (response.errors) {
          setFieldErrors(response.errors);
        }
        setError(response.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsPending(false);
    }
  };
  const resetForm = () => {
    setIsSubmitted(false);
    setError(null);
    setFieldErrors({});
  };
  if (isSubmitted) {
    return <div className="p-4">
                <h3 className="text-md font-semibold mb-3">Thank you.</h3>
                <p className="text-sm mb-4">
                    The details of your order have been emailed to the address on file.
                </p>

                <div className="mb-2">
                    <button onClick={resetForm} className="text-sm text-primary hover:underline">
                        get status of another order?
                    </button>
                </div>
                <div className="mb-4">
                    <button onClick={() => setPanel('main')} className="text-sm text-primary hover:underline">
                        return to help menu
                    </button>
                </div>

                <ContactInfo />
            </div>;
  }
  return <div className="p-4">
            <h3 className="text-md font-semibold mb-2">Order Status</h3>
            <p className="text-sm text-light mb-4">
                Enter your email address and order number below and we'll send the latest update on your order right away. If you need additional assistance, don't hesitate to call us toll free at{' '}
                <a href="tel:+18666634483" className="text-primary hover:underline">1.866.663.4483</a>.
            </p>

            <form action={handleSubmit}>
                {error && <div className="text-red text-sm mb-3">{error}</div>}

                <div className="form-group mb-3">
                    {fieldErrors.email && <div className="text-red text-xs mb-1">{fieldErrors.email}</div>}
                    <input type="email" name="email" autoComplete="email" className="form-input form-input-sm peer" placeholder=" " required disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        email <span className="text-primary">*</span>
                    </label>
                </div>

                <div className="form-group mb-4">
                    {fieldErrors.order_id && <div className="text-red text-xs mb-1">{fieldErrors.order_id}</div>}
                    <input type="text" name="order_id" autoComplete="off" className="form-input form-input-sm peer" placeholder=" " required disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        order id <span className="text-primary">*</span>
                    </label>
                </div>

                <button type="submit" disabled={isPending} className={`btn btn-primary btn-sm w-full ${isPending ? 'opacity-50' : ''}`}>
                    {isPending ? 'submitting...' : 'submit request'}
                </button>
            </form>
        </div>;
};
const ContactInfo = () => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-primary font-medium">hive</div>;
    t1 = <div>820 nw glisan street</div>;
    t2 = <div>portland or 97209</div>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>tele: <a href="tel:+15032421967" className="hover:text-primary">503.242.1967</a></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>fax: <a href="tel:+15032425573" className="hover:text-primary">503.242.5573</a></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-sm text-light mt-4 pt-4 border-t border-gray-10">{t0}{t1}{t2}{t3}{t4}<div>toll-free: <a href="tel:+18666634483" className="hover:text-primary">1.866.663.4483</a></div><div><a href="mailto:info@hivemodern.com" className="text-primary hover:underline">info@hivemodern.com</a></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default HelpOrderStatus;